import Component from './LocalesSwitcher.container';

export { Component };

export default Component;
